module.exports = __WEBPACK_EXTERNAL_MODULE_88__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 88
// module chunks = 0 1